export const OVERVIEW_CONTENT = {
  title: 'CWY Rewards & Token',
  eyebrow: 'About 5 minutes',
  lead:
    'CWY is Canadawale Yar’s Solana utility token for rewards on the platform. This guide shows how to connect a wallet and send or receive CWY safely.',
  rewardsUrl: 'https://canadawaleyar.com/rewards',
  checklist: [
    'Install a Solana wallet (Phantom, Nightly, Solflare, Backpack, or Brave)',
    'Connect it to your CWY account',
    'Receive CWY tokens to your wallet',
    'Send CWY back to the vault when you want',
  ],
  receiveCard: {
    title: 'Receive',
    body: 'Request CWY tokens to your connected wallet.',
  },
  sendCard: {
    title: 'Send',
    body: 'Return CWY from your wallet to the CWY vault.',
  },
  sections: [
    {
      heading: 'What is the CWY Rewards program?',
      body: [
        'The CWY Rewards program is how Canadawale Yar recognizes and rewards members on the platform.',
        'See the full program on our Rewards page. This guide covers the practical steps: install a wallet, connect it, then send or receive CWY.',
      ],
    },
    {
      heading: 'What is the CWY token?',
      body: [
        'CWY is a utility token on Solana. It is used inside Canadawale Yar for rewards and related activity — it is not a bank account or cash.',
      ],
    },
    {
      heading: 'Before you start',
      body: [
        'You need a Solana wallet. We support Phantom, Solflare, Nightly, Backpack, and Brave Wallet — each has a full walkthrough with screenshots in this guide.',
      ],
    },
    {
      heading: 'Stay safe',
      body: [],
      bullets: [
        'Only download wallets from official sites (Phantom: phantom.com, Nightly: nightly.app, Solflare: solflare.com, Backpack: backpack.app, Brave: brave.com).',
        'Never share your recovery phrase with anyone — CWY staff will never ask for it.',
        'Double-check you are on canadawaleyar.com before connecting your wallet.',
        'CWY tokens are not the same as Canadian dollars or bank money.',
      ],
    },
  ],
} as const;
